// config
import * as http from 'utils/http';
import config from 'config';

const createFilterView = async ({ filterViewDto }) => {
  const endpoint = `${config.API_URL}price-negotiation/filter-views/`;
  return http.post(endpoint, filterViewDto);
};

export default createFilterView;
